import React, { useState } from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { useSpring } from 'react-spring'

import {
  TestimonialSection,
  TestimonialContainer,
  Testimonial,
  TestimonialHolder,
  Paragraph,
  AnimatedParagraphContainer,
  Author,
  Desc
  } from './styles'
  
  const Items = ({ data }) => {
    
  const [open, setOpen] = useState(false)
    
  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        const len = children[0].length
  
        const newtext = len > 200 ? children[0].slice(0, 200) : children
        return (
          <>
            <Paragraph>{open ? children : newtext}{!open && len > 200 ? '...' : ''}{!open && len > 200 ? <span onClick={() => { setOpen(!open) }}>Read More</span> : open && len > 200 ? <span onClick={() => { setOpen(!open) }}>.Read Less</span> : ''}</Paragraph>
          </>
        )
      },
    },
  }

  const props = useSpring({
    from: { height: 120, overflow: 'hidden' },
    to: {
      height: open ? 'auto' : 120,
    },
    reset: true,
  })

  
  return (
    <TestimonialHolder>
      <Testimonial>
        <AnimatedParagraphContainer style={props}>{documentToReactComponents(data.node.body.json, options)}</AnimatedParagraphContainer>
        <Author>{data.node.author}</Author>
        <Desc>{data.node?.authorDescription}</Desc>
      </Testimonial>
    </TestimonialHolder>
  )
}

const TestimonialItems = ({ testimony }) => {
  return (
    <TestimonialSection>
      <TestimonialContainer>
        {
          testimony.map((x, i) => {
            return (
              <Items data={x} key={i}/>
            )
          })
        }
      </TestimonialContainer>
    </TestimonialSection>
  )
}

export default TestimonialItems
